<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">Add API to Role
              <form
                class="roleDropdown"
                @submit.prevent=""
              >
                <b-form-select
                  id="statusFilter"
                  v-model="roleSelection"
                  class="full-width"
                  @change.native="onChange"
                >
                  <option
                    v-for="role in userRoles"
                    v-bind="$attrs"
                    :key="role.id"
                    :value="role.id"
                    @option="$emit('option', $event.target.value)"
                  >
                    {{ role.name }}
                  </option>
                </b-form-select>
              </form>
            </span>
          </div>

          <b-table
            striped
            hover
            :items="APIs"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template
              slot="apiID"
              slot-scope="data"
            >
              <b-form-checkbox
                v-model="checkedAPIs"
                :plain="true"
                value="data.item.apiID"
                unchecked-value="0"
                :value="data.item.apiID"
                @change.native="clickHandler"
              />
            </template>
          </b-table>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import addApi2RoleMixin from '../mixins/addApi2RoleMixin'

export default {
  name: 'AddApi2Role',
  mixins: [addApi2RoleMixin]
}
</script>
<style media="screen">

  td.width-250 {
    width: 250px;
    max-width: 250px;
  }

  .roleDropdown {
    width: 250px;
    max-width: 250px;
    display: inline-block;
  }

</style>
